import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminCustomers() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/customers").then(({data}) => setItems(data)); }, []);
  return (
    <div className="p-8 lg:p-12" data-testid="admin-customers">
      <h1 className="font-display text-3xl">Customers</h1>
      <p className="text-black/50 mt-1">All registered customer accounts.</p>
      <div className="mt-8 bg-white border border-[#EAEAEA] rounded-xl overflow-hidden">
        <table className="w-full text-sm sk-table">
          <thead>
            <tr className="text-left text-xs uppercase tracking-widest text-black/50 bg-black/[0.02]">
              <th className="py-3 px-4">Name</th><th>Email</th><th>Phone</th><th>Applications</th><th>Joined</th>
            </tr>
          </thead>
          <tbody>
            {items.map(c => (
              <tr key={c.id} className="border-t border-[#EEE]" data-testid={`customer-row-${c.id}`}>
                <td className="py-3 px-4 font-medium">{c.name}</td>
                <td>{c.email}</td>
                <td>{c.phone}</td>
                <td><span className="sk-badge bg-[#D4AF37]/15 text-[#8A6E1E]">{c.lead_count}</span></td>
                <td className="text-xs text-black/50">{new Date(c.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
            {items.length===0 && <tr><td colSpan="5" className="py-12 text-center text-black/40">No customers yet</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
